<app-base-modal
  [title]="'Видео отзыва'"
  [isNeedFullScreenBtn]="true"
>
  <div class="container">
    <video
      #videoElement
      controls
      class="content"
      [class.fullscreen]="fullScreenStateService.fullScreenState()"
    ></video>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>

